module.exports = __webpack_public_path__ + "img/9791185298764.eff4eafc.jpg";